import BookDetails from '../components/BookDetails';
import AppHeader from '../components/AppHeader';

const BookDetailsPage = () => {

  return (
    <>
    <AppHeader/>
    <BookDetails/> 
    </>
  );
};

export default BookDetailsPage;
